import { FC, memo } from "react"
import { Box, Collapse, Flex, Text, useDisclosure } from "@chakra-ui/react"
import "../../../css/MobileDetailDialog.scss"
import { QRCodeCanvas } from "qrcode.react";
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation";

type Props ={
    url:string
}

export const QRcode:FC<Props>=memo((props)=>{
    const { url } =props
    const { isOpen, onToggle } = useDisclosure()
    return(
        <>
            <Text 
            className="body" 
            style={{userSelect:"none", 
                    textDecorationLine: 'underline',
                    textDecorationColor: 'blue',
                    textDecorationStyle: 'solid', 
                    color:"blue" }} 
            whiteSpace="pre-wrap" 
            pt="16px" 
            fontSize={`${WidthCalculation(24,24)}px`}
            lineHeight={`${HeightCalculation(36,36)}px`}
            color="gray.700"
            onClick={onToggle}
            >
                {url}
            </Text>  
            <Collapse in={isOpen} animateOpacity >
                <br/>
                <Flex justifyContent="center" alignItems="center">
                    <QRCodeCanvas
                    value={url}
                    size={WidthCalculation(300,300)}
                    level={"Q"}
                    />
                </Flex>
            </Collapse>
        </>
)
  })